import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionV2StepDetailPage } from '../../../../../../components/pages/subscription-v2/subscription-v2-step-detail-page.tsx'

export const Route = createFileRoute('/subscribe/$subscriptionId/$stepId/$detailType/$detailId')({
  component: SubscriptionV2StepDetailPage,
})
